import { PageType } from "@product/scmp-sdk";

export const pathname = "/posties/kids";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.PostiesKids } };
  },
};
